module.exports = __webpack_public_path__ + "img/visa.824ecf2d.svg";